import { ID, RecordObject } from 'src/models/general.model';
import { NotificationMessage } from 'src/models/notification.model';

export interface NotificationsStore {
  messages?: NotificationMessage[];
  pageSubscriptions?: RecordObject<ID[]>;
}

export const INITIAL_NOTIFICATIONS_STORE_STATE: NotificationsStore = {};
